module.exports = __webpack_public_path__ + "b841adc708097b0933bb393a1e42b716.svg";